import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import { Subscription } from '../models';

export const SUBSCRIPTION_API_URL = `${environment.apps.kanga}/api/v1/accounts/`;

interface GetSubscriptionResponse {
  uuid: string;
  first_name: string;
  last_name: string;
  email: string;
  occupation: string;
  status: string;
  licenses: string[];
  session_minutes_left: number;
}

@Injectable({ providedIn: 'root' })
export class SubscriptionApiService {
  constructor(private httpClient: HttpClient) {}

  getSubscription(accountId: string, userId: string): Observable<Subscription> {
    return this.httpClient
      .get<GetSubscriptionResponse>(
        `${SUBSCRIPTION_API_URL}${accountId}/users/${userId}/`
      )
      .pipe(
        map((res) => ({
          license: res.licenses[0],
          occupation: res.occupation,
          session_minutes_left: res.session_minutes_left,
        }))
      );
  }
}
